export default __webpack_public_path__ + "static/media/NotoSans-Light.a1b97753.eot";